import { Injectable } from '@angular/core';
import { Headers, Http, Response } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class HighStockService {
    private subUrl = "http://cloud.agroclimate.org/tools/kddMonitoring/ws/getpixelvalue.php?var=";
    constructor(private http: Http) {
    }

    getChartData(variable: string, base: number, from: string, to: string, latlon: string, format: string) {
        let url = this.subUrl + variable + "&b=" + base + "&from=" + from + "&to=" + to + "&latlon=" + latlon + "&format=" + format;
        return this.http.get(url)
            .map((response: Response) => response.json())
            .catch((error: Response) => Promise.reject(error));
    }
}



// WEBPACK FOOTER //
// ./src/app/charts/high-stock-chart/high-stock.service.ts